/**
 * @generated SignedSource<<78d0c28ad6260903bcffb5ad036ce0ec>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionHistoryFragment$data = {
  readonly createdAt: DateTime;
  readonly id: string;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspacePublishButtonFragment">;
  readonly " $fragmentType": "WorkspaceVersionHistoryFragment";
};
export type WorkspaceVersionHistoryFragment$key = {
  readonly " $data"?: WorkspaceVersionHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionHistoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionHistoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspacePublishButtonFragment"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "51f45f9562719eff5f0ab43ae5904eaf";

export default node;
